import React from 'react';
export function Impressum() {
  return <main className="max-w-[800px] mx-auto w-full px-6 py-10 flex-1" data-id="element-338">
      <h1 className="font-serif text-[2rem] font-bold text-brand-navy mb-8" data-id="element-339">
        Impressum
      </h1>

      <div className="font-body text-[1.1rem] leading-[1.8] text-brand-gray-600 space-y-6" data-id="element-340">
        <section data-id="element-341">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-342">
            Angaben gemäß § 5 TMG
          </h2>
          <p data-id="element-343">
            Emerald Health Solutions Ltd.
            <br data-id="element-344" />
            Unit 12, Business Centre, Sandyford
            <br data-id="element-345" />
            Dublin 18, D18 X2P9, Ireland
          </p>
        </section>

        <section data-id="element-346">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-347">
            Vertreten durch
          </h2>
          <p data-id="element-348">Director: Liam O'Connor</p>
        </section>

        <section data-id="element-349">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-350">
            Kontakt
          </h2>
          <p data-id="element-351">
            Telefon: +353 1 496 0123
            <br data-id="element-352" />
            E-Mail: contact@emerald-health.ie
          </p>
        </section>

        <section data-id="element-353">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-354">
            Registereintrag
          </h2>
          <p data-id="element-355">
            Eintragung im Handelsregister.
            <br data-id="element-356" />
            Company Registration Number: 742185
          </p>
        </section>

        <section data-id="element-357">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-358">
            Umsatzsteuer-ID
          </h2>
          <p data-id="element-359">
            Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
            <br data-id="element-360" />
            IE9988776W
          </p>
        </section>

        <section data-id="element-361">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-362">
            Haftung für Inhalte
          </h2>
          <p data-id="element-363">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte
            auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach
            §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
            verpflichtet, übermittelte oder gespeicherte fremde Informationen zu
            überwachen oder nach Umständen zu forschen, die auf eine
            rechtswidrige Tätigkeit hinweisen.
          </p>
        </section>

        <section data-id="element-364">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-365">
            Haftung für Links
          </h2>
          <p data-id="element-366">
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
            verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
            der Seiten verantwortlich.
          </p>
        </section>

        <section data-id="element-367">
          <h2 className="font-serif text-[1.4rem] font-semibold text-brand-navy mb-3" data-id="element-368">
            Urheberrecht
          </h2>
          <p data-id="element-369">
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
            diesen Seiten unterliegen dem deutschen Urheberrecht. Die
            Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
            Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
            schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
          </p>
        </section>
      </div>
    </main>;
}